import { render } from "./EnterCodeScreen.vue?vue&type=template&id=85c92d06"
import script from "./EnterCodeScreen.vue?vue&type=script&lang=js"
export * from "./EnterCodeScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__